import QuestionController from "../question_controller"

export default class extends QuestionController {

  validateForm() {
    this.toggleFlash(false)
    if(this.isRequired() && this.hasTextInputFieldTarget && this.blankAnswer()) {
      this.displayFlash("danger", "Please add an answer for this question.")
      return false
    }

    if(!this.limitSelection() || (this.minSelection() === null && this.maxSelection() === null)) return true

    if ( !this.blankAnswer() && this.limitSelection() && this.minSelection() !== null && this.maxSelection ()!== null && (this.textInputFieldTarget.value < this.minSelection() || this.textInputFieldTarget.value > this.maxSelection())) {
      this.displayFlash("danger", `Your answer must be between ${this.minSelection()} and ${this.maxSelection()}.`)
      return false
    }

    if ( !this.blankAnswer() && this.limitSelection() && this.minSelection() !== null && this.textInputFieldTarget.value < this.minSelection()) {
      this.displayFlash("danger", `Your answer must be more than ${this.minSelection() - 1}.`)
      return false
    }

    if ( !this.blankAnswer() && this.limitSelection() && this.maxSelection() !== null && this.textInputFieldTarget.value > this.maxSelection()) {
      this.displayFlash("danger", `Your answer must be less than ${this.maxSelection() + 1}.`)
      return false
    }


    return true
  }
}
